<template>
    <div>
        <van-nav-bar :title="$route.meta.title" left-arrow @click-left="$router.push('/home')" />
        <van-cell-group inset>
            <van-cell title="用户ID" :value="userInfo.id" />
            <van-cell title="绑定微信" :value="userInfo.is_verified ? '已绑定' : '未绑定'" />
        </van-cell-group>
        <van-cell-group inset>
            <van-cell title="头像">
                <van-image round width="2rem" height="2rem" :src="userInfo.avatar" />
            </van-cell>
            <van-cell title="昵称" :value="userInfo.nickname" />
            <van-cell title="手机号" :value="userInfo.phone" />
            <van-cell title="签名" />
        </van-cell-group>
        <van-cell-group inset>
            <van-cell title="更改密码" @click="$refs['change-password'].show()" />
        </van-cell-group>
        <change-login-password ref="change-password" />
    </div>
</template>

<script>
import ChangeLoginPassword from './ChangeLoginPassword.vue'
import { LOGIN_USER } from '@/utils/constants'

export default {
    components: { ChangeLoginPassword },
    data() {
        return {
            userInfo: {},
        }
    },
    created() {
        this.userInfo = this.$ls.get(LOGIN_USER)
    },
    methods: {},
}
</script>

<style lang="less" scoped>
.van-cell-group {
    margin-top: 15px;
}
</style>
